// @flow weak

import { routerReducer }    from 'react-router-redux';
import { combineReducers }  from 'redux';

import user from './user';
import authentication       from './authentication';
import views                from './views';
import sideMenu             from './sideMenu';

import countryCityReducers from './countryCityReducers';
import siteReducer from './siteReducer';
import alertsReducer from './alertsReducer';
import reportReducer from './reportReducer';
import announcementsReducers from './announcementsReducers';
import bannersReducers from './bannersReducers';
import invoicesReducers from './invoicesReducers';

export const mainReducers = {
  user,
  authentication,
  countryCityReducers,
  announcementsReducers,
  bannersReducers,
  invoicesReducers,
  sideMenu,
  views,
  siteReducer,
  alertsReducer,
  reportReducer
};

export default combineReducers({
  ...mainReducers,
  routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/app/redux/reducers/mainReducers.js